export const enServiceBooking = {
  hero: {
    title: "Home Services Booking Platform",
    subtitle:
      "Full-stack service platform with mobile apps, web interface and admin panel",
    imageAlt: "Home services platform showing booking interface",
  },
  features: {
    bookingSystem: {
      title: "Booking System",
      description:
        "Real-time scheduling with calendar integration and instant confirmations",
    },
    multiPlatform: {
      title: "Multi-Platform",
      description:
        "Native mobile apps and responsive web interface for all devices",
    },
    aiAssisted: {
      title: "AI-Assisted Matching",
      description:
        "Smart service recommendations and automated provider-customer matching",
    },
    roleManagement: {
      title: "Role Management",
      description:
        "Granular permissions for admins, service providers and customers",
    },
    communication: {
      title: "Communication Tools",
      description:
        "In-app chat, push notifications and email integrations with templates",
    },
    analytics: {
      title: "Advanced Analytics",
      description:
        "Real-time business insights and performance tracking dashboards",
    },
  },
  techStack: {
    title: "Technology Stack",
    backend: {
      title: "Backend",
      laravel: "Laravel PHP framework for robust operations",
      api: "API-first architecture with microservices",
      security: "End-to-end encryption and RBAC",
    },
    frontend: {
      title: "Frontend",
      mobile: "Flutter for cross-platform mobile apps",
      web: "Vue.js with Nuxt.js for web platform",
      state: "Vuex for state management",
    },
    features: {
      title: "Integrations",
      payments: "Stripe, PayPal payment gateways",
      maps: "Google Maps API integration",
      calendar: "Google Calendar and Outlook sync",
    },
  },
  dashboard: {
    title: "Powerful Management Dashboard",
    description:
      "Complete control over your home services business with real-time monitoring tools.",
    demoAlt: "Home services admin dashboard preview",
    features: {
      1: "Multi-platform management console",
      2: "Real-time booking analytics",
      3: "AI-powered dispatch system",
      4: "Service provider performance tracking",
      5: "Customer satisfaction metrics",
    },
  },
  cta: {
    title: "Ready to Transform Your Service Business?",
    description:
      "Discover how our platform can streamline your operations and grow your customer base",
    buttonText: "View Demo",
    buttonAriaLabel: "View demo of the home services platform",
  },
};

export const frServiceBooking = {
  hero: {
    title: "Plateforme de réservation de services à domicile",
    subtitle:
      "Plateforme de services full-stack avec applications mobiles, interface web et panneau d'administration",
    imageAlt:
      "Plateforme de services à domicile montrant l'interface de réservation",
  },
  features: {
    bookingSystem: {
      title: "Système de réservation",
      description:
        "Planification en temps réel avec intégration de calendrier et confirmations instantanées",
    },
    multiPlatform: {
      title: "Multi-plateforme",
      description:
        "Applications mobiles natives et interface web responsive pour tous les appareils",
    },
    aiAssisted: {
      title: "Correspondance assistée par IA",
      description:
        "Recommandations de services intelligentes et correspondance automatisée entre fournisseurs et clients",
    },
    roleManagement: {
      title: "Gestion des rôles",
      description:
        "Autorisations granulaires pour les administrateurs, les fournisseurs de services et les clients",
    },
    communication: {
      title: "Outils de communication",
      description:
        "Chat intégré, notifications push et intégrations par e-mail avec modèles",
    },
    analytics: {
      title: "Analytique avancée",
      description:
        "Informations commerciales en temps réel et tableaux de bord de suivi des performances",
    },
  },
  techStack: {
    title: "Technologie Stack",
    backend: {
      title: "Backend",
      laravel: "Framework Laravel PHP pour des opérations robustes",
      api: "Architecture API-first avec microservices",
      security: "Chiffrement de bout en bout et RBAC",
    },
    frontend: {
      title: "Frontend",
      mobile: "Flutter pour des applications mobiles multiplateformes",
      web: "Vue.js avec Nuxt.js pour la plateforme web",
      state: "Vuex pour la gestion de l'état",
    },
    features: {
      title: "Intégrations",
      payments: "Passerelles de paiement Stripe, PayPal",
      maps: "Intégration de l'API Google Maps",
      calendar: "Synchronisation avec Google Calendar et Outlook",
    },
  },
  dashboard: {
    title: "Tableau de bord de gestion puissant",
    description:
      "Contrôle total de votre entreprise de services à domicile avec des outils de surveillance en temps réel.",
    demoAlt: "Aperçu du tableau de bord administrateur des services à domicile",
    features: {
      1: "Console de gestion multi-plateforme",
      2: "Analytique de réservation en temps réel",
      3: "Système de répartition alimenté par IA",
      4: "Suivi des performances des fournisseurs de services",
      5: "Métriques de satisfaction client",
    },
  },
  cta: {
    title: "Prêt à transformer votre entreprise de services?",
    description:
      "Découvrez comment notre plateforme peut rationaliser vos opérations et développer votre clientèle",
    buttonText: "Voir la démo",
    buttonAriaLabel:
      "Voir la démo de la plateforme de services à domicile",
  },
};

export const nlServiceBooking = {
  hero: {
    title: "Boekingsplatform voor thuisdiensten",
    subtitle:
      "Full-stack serviceplatform met mobiele apps, webinterface en adminpanel",
    imageAlt: "Thuisdienstenplatform toont boekingsinterface",
  },
  features: {
    bookingSystem: {
      title: "Boekingssysteem",
      description:
        "Realtime planning met kalenderintegratie en directe bevestigingen",
    },
    multiPlatform: {
      title: "Multi-platform",
      description:
        "Native mobiele apps en responsieve webinterface voor alle apparaten",
    },
    aiAssisted: {
      title: "AI-ondersteunde matching",
      description:
        "Slimme servicerecommendaties en geautomatiseerde provider-klant matching",
    },
    roleManagement: {
      title: "Rolbeheer",
      description:
        "Gedetailleerde rechten voor admins, dienstverleners en klanten",
    },
    communication: {
      title: "Communicatietools",
      description:
        "In-app chat, pushmeldingen en e-mailintegraties met templates",
    },
    analytics: {
      title: "Geavanceerde analytics",
      description:
        "Realtime zakelijke inzichten en prestatie-dashboards",
    },
  },
  techStack: {
    title: "Technologiestack",
    backend: {
      title: "Backend",
      laravel: "Laravel PHP framework voor robuuste operaties",
      api: "API-first architectuur met microservices",
      security: "End-to-end encryptie en RBAC",
    },
    frontend: {
      title: "Frontend",
      mobile: "Flutter voor cross-platform mobiele apps",
      web: "Vue.js met Nuxt.js voor webplatform",
      state: "Vuex voor state management",
    },
    features: {
      title: "Integraties",
      payments: "Stripe, PayPal betaalgateways",
      maps: "Google Maps API-integratie",
      calendar: "Google Calendar en Outlook synchronisatie",
    },
  },
  dashboard: {
    title: "Krachtig beheerdashboard",
    description:
      "Volledige controle over uw thuisdienstenbedrijf met realtime monitoringtools.",
    demoAlt: "Preview van thuisdiensten admin dashboard",
    features: {
      1: "Multi-platform managementconsole",
      2: "Realtime boekingsanalytics",
      3: "AI-gestuurd dispatchsysteem",
      4: "Prestatie tracking van dienstverleners",
      5: "Klanttevredenheidsmetrics",
    },
  },
  cta: {
    title: "Klaar om uw servicebedrijf te transformeren?",
    description:
      "Ontdek hoe ons platform uw operaties kan stroomlijnen en uw klantenbestand kan laten groeien",
    buttonText: "Bekijk Demo",
    buttonAriaLabel: "Bekijk demo van het thuisdienstenplatform",
  },
};

export const deServiceBooking = {
  hero: {
    title: "Buchungsplattform für Hausdienstleistungen",
    subtitle:
      "Full-Stack-Serviceplattform mit mobilen Apps, Weboberfläche und Admin-Panel",
    imageAlt: "Hausdienstleistungsplattform zeigt Buchungsoberfläche",
  },
  features: {
    bookingSystem: {
      title: "Buchungssystem",
      description:
        "Echtzeitplanung mit Kalenderintegration und sofortigen Bestätigungen",
    },
    multiPlatform: {
      title: "Multi-Plattform",
      description:
        "Native Mobile Apps und responsives Webinterface für alle Geräte",
    },
    aiAssisted: {
      title: "KI-gestützte Vermittlung",
      description:
        "Intelligente Serviceempfehlungen und automatisiertes Anbieter-Kunden-Matching",
    },
    roleManagement: {
      title: "Rollenmanagement",
      description:
        "Granulare Berechtigungen für Admins, Dienstleister und Kunden",
    },
    communication: {
      title: "Kommunikationstools",
      description:
        "In-App-Chat, Push-Benachrichtigungen und E-Mail-Integrationen mit Vorlagen",
    },
    analytics: {
      title: "Erweiterte Analytik",
      description:
        "Echtzeit-Geschäftseinblicke und Performance-Dashboards",
    },
  },
  techStack: {
    title: "Technologie-Stack",
    backend: {
      title: "Backend",
      laravel: "Laravel PHP Framework für robuste Abläufe",
      api: "API-First-Architektur mit Microservices",
      security: "End-to-End-Verschlüsselung und RBAC",
    },
    frontend: {
      title: "Frontend",
      mobile: "Flutter für plattformübergreifende Mobile Apps",
      web: "Vue.js mit Nuxt.js für die Webplattform",
      state: "Vuex für State Management",
    },
    features: {
      title: "Integrationen",
      payments: "Stripe, PayPal Zahlungs-Gateways",
      maps: "Google Maps API-Integration",
      calendar: "Google Calendar und Outlook-Synchronisierung",
    },
  },
  dashboard: {
    title: "Leistungsstarkes Verwaltungsdashboard",
    description:
      "Vollständige Kontrolle über Ihr Hausdienstleistungsunternehmen mit Echtzeit-Überwachungstools.",
    demoAlt: "Vorschau des Hausdienstleistungs-Admin-Dashboards",
    features: {
      1: "Multi-Plattform-Managementkonsole",
      2: "Echtzeit-Buchungsanalytik",
      3: "KI-gestütztes Dispatch-System",
      4: "Leistungstracking der Dienstleister",
      5: "Kundenzufriedenheitsmetriken",
    },
  },
  cta: {
    title: "Bereit, Ihr Serviceunternehmen zu transformieren?",
    description:
      "Erfahren Sie, wie unsere Plattform Ihre Abläufe optimieren und Ihren Kundenstamm erweitern kann",
    buttonText: "Demo ansehen",
    buttonAriaLabel: "Demo der Hausdienstleistungsplattform ansehen",
  },
};
